var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('canvas',{attrs:{"id":"canvas","width":"300","height":"300"}}),_c('div',{ref:"editable",staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)},on:{"click":_vm.handleContentClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }